import * as React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

interface ICmsCardProps {
  headline: string;
  bodyText: string;
  image?: string;
}

const useStyles = makeStyles({
  root: {
    marginBottom: '15px',
  },
  media: {
    height: 140,
  },
});

const CmsCard: React.FC<ICmsCardProps> = ({
  bodyText,
  headline,
  image,
}): JSX.Element => {
  const classes = useStyles({});

  return (
    <Card className={classes.root}>
      <CardActionArea>
        {image && <CardMedia className={classes.media} image={image} />}

        <CardContent>
          <Typography
            gutterBottom
            variant='h5'
            component='h2'
            dangerouslySetInnerHTML={{ __html: headline }}
          />
          <Typography
            variant='body2'
            color='textSecondary'
            component='p'
            dangerouslySetInnerHTML={{ __html: bodyText }}
          />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CmsCard;
